import actions from './actions';
import authActions from '../auth/actions';

const initState = {
  errorMessage: null,
  isError: false,
  message: null,
  view: null,
  resetErrorMessage: null,
  resetError: false,
  resettingTokenData: false,
  hasResetTokenData: null,
  resettingMerchantUserPassword: false,
  merchantPasswordResetData: null,
  newMerchantUserPasswordReset: false,
  merchantData: null,
  elasticMerchantData: null,
  elasticMerchantLoading: false,
  pageLoading: false,
  merchantLoading: false,
  activeMerchant: null,
  activeMerchantLoading: false,

  merchantFiles: null,
  merchantFilesLoading: false,
  merchantFilesFilter: null,
  merchantFilesLoadMore: false,
  merchantFilesPagination: null,

  merchantPchannels: null,
  merchantPchannelsLoading: false,
  pchannelError: false,
  merchantLogs: null,
  merchantLogsPagination: null,
  logsError: false,
  amountLevelData: null,
  amountLevelLoading: false,
  amountLevelError: false,
  merchantParentData: null,
  merchantParentLoading: false,
  merchantParentIsError: false,
  fileManagementData: null,
  fileManagementPagination: null,
  fileManagementError: false,
  fileManagementLoading: false,
  isFileError: false,
  fileLoading: false,
  fileDownloadData: null,

  merchantConfigurationLoading: false,
  merchantConfigurationData: null,
  merchantConfigurationIsError: false,

  merchantSettingsTypeLoading: false,
  merchantSettingsTypeData: null,
  merchantSettingsTypeIsError: false,
  merchantSettingsTypeFilter: null,

  merchantPChannelConfigLoading: false,
  merchantPChannelConfigData: null,
  merchantPChannelConfigIsError: false,

  merchantFeeLoading: false,
  merchantFeeData: null,
  merchantFeeIsError: false,

  invitedMerchantDataLoading: false,
  invitedMerchantData: null,
  invitedMerchantDataIsError: false,

  logAccessLoading: false,

  ptiTestMerchantUsersLoading: false,
  ptiTestMerchantUsersData: null,
  ptiTestMerchantUsersFilter: null,
  ptiTestMerchantUsersLoadMore: false,
  ptiTestMerchantUsersPagination: null,

  ptiProdMerchantUsersLoading: false,
  ptiProdMerchantUsersData: null,
  ptiProdMerchantUsersFilter: null,
  ptiProdMerchantUsersLoadMore: false,
  ptiProdMerchantUsersPagination: null,

  //Merchant Profile V2 User Management
  ptiMerchantUserData: null,
  ptiMerchantUserDataIsLoading: false,
  ptiMerchantUserDataFilter: null,
  ptiMerchantUserDataPagination: null,
  ptiMerchantUserDataLoadMore: false,
  ptiMerchantUserDataHasError: false,

  merchantUserManagementLoading: false,

  signUpUserStatus: false,

  invitedMerchantUserLoading: false,
  invitedMerchantUserData: null,
  invitedMerchantUserIsError: false,

  merchantInformation: null,
  merchantInformationLoading: false,
  merchantInformationIsError: false,
  activeMerchantInformation: null,
  merchantFilter: null,
  merchantDataPagination: null,
  merchantDataLoadMore: false,

  misOptions: null,
  misOptionsLoading: false,
  misOptionsIsError: false,

  misMerchantDetails: null,
  misMerchantDetailsLoading: false,
  misMerchantDetailsIsError: false,

  kybLinkStatus: null,
  kybLinkStatusLoading: false,
  kybLinkStatusIsError: false,

  merchantFromOnboardingLoading: false,
  merchantFromOnboarding: null,
  merchantFromOnboardingIsError: false,
  merchantFromOnboardingFilter: null,
  merchantFromOnboardingPagination: null,
  merchantFromOnboardingLoadMore: false,
  activeMerchantFromOnboarding: null,

  paybizDetails: null,
  paybizDetailsLoading: false,
  paybizDetailsHasError: false,

  integrationFormRequestById: null,
  integrationFormRequestByIdLoading: false,
  integrationFormRequestByIdHasError: false,

  paybizMerchantsLoading: false,
  paybizMerchants: null,
  paybizMerchantsTotalCount: null,
  paybizMerchantFilter: null,
  paybizMerchantsHasError: false,

  allCosmosLeadsMerchant: null,
  allCosmosLeadsMerchantIsError: false,
  allCosmosLeadsMerchantLoading: false,
  allCosmosLeadsMerchantLoadMore: false,

  existingMerchantLogsLoading: false,
  existingMerchantLogsData: null,
  existingMerchantLogsIsError: false,
  existingMerchantLogsPagination: null,
  existingMerchantLogsLoadMore: false,

  companyInformationData: null,
  companyInformationLoading: false,

  submitMISFormDataLoading: false,

  parentMerchants: null,
  parentMerchantsLoading: false,

  merchantInfoMIDs: null,
  merchantInfoMIDsLoading: false,

  integrationFormRequestsLoadMore: false,
  integrationFormRequestsIsError: false,
  integrationFormRequestsLoading: false,
  integrationFormRequestsData: null,
  integrationFormRequestsFilter: null,

  integrationFormLogsLoadMore: false,
  integrationFormLogsIsError: false,
  integrationFormLogsLoading: false,
  integrationFormLogsData: null,
  integrationFormLogsFilter: null,

  merchantProfileLogsLoadMore: false,
  merchantProfileLogsIsError: false,
  merchantProfileLogsLoading: false,
  merchantProfileLogsData: null,
  merchantProfileLogsFilter: null,
  merchantProfileLogsPagination: null,

  merchantCredentialsById: null,
  merchantCredentialsByIdUnmaskedFields: null,
  merchantCredentialsByIdLoading: false,
  merchantCredentialsByIdHasError: false,

  integrationRequestFormReportLoading: false,
  integrationRequestFormReportIsError: false,

  isDownloadingIntegrationRequestFormReportFile: false,
  isDownloadingIntegrationRequestFormReportFileError: null,

  allIntegrationRequestFormReportDataLoading: false,
  allIntegrationRequestFormReportFileData: null,
  allIntegrationRequestFormReportFileDataIsError: false,
  allIntegrationRequestFormReportFileDataPagination: false,

  generateMerchantCredentialsLoading: false,
  generateMerchantCredentialsHasError: false,

  addMerchantPaymentChannelLoading: false,
  addMerchantPaymentChannelHasError: false,

  presignedUrlsTestingProofFilesLoading: false,
  presignedUrlsTestingProofFiles: null,
  presignedUrlsTestingProofFilesIsError: false,
  downloadTestingProofFilesLoading: false,
  downloadTestingProofFilesIsError: false,

  uploadTestingProofFileLoading: false,
  uploadTestingProofFileHasError: false,

  testingProofFilesById: null,
  testingProofFilesByIdLoading: false,
  testingProofFilesByIdHasError: false,

  downloadTestingProofFileURL: null,
  downloadTestingProofFileLoading: false,
  downloadTestingProofFileIsError: false,

  downloadIRFTestingProofFileLoading: false,
  downloadIRFTestingProofFileIsError: false,

  merchantPaymentChannelsById: null,
  merchantPaymentChannelsByIdLoading: false,
  merchantPaymentChannelsByIdHasError: false,

  merchantKrakenPaymentChannelsById: null,
  merchantKrakenPaymentChannelsByIdLoading: false,
  merchantKrakenPaymentChannelsByIdHasError: false,

  presignedUrlsForIRFProofTestFileLoading: false,
  presignedUrlsForIRFProofTestFileData: null,
  presignedUrlsForIRFProofTestFileIsError: null,

  testingIrfProofFilesById: null,
  testingIrfProofFilesByIdLoading: false,
  testingIrfProofFilesByIdHasError: false,

  downloadTestingIrfProofFileLoading: false,
  downloadTestingIrfProofFileIsError: false,

  merchantCertificateConfigurationLoading: false,

  merchantTestCertificateData: null,
  merchantTestCertificateDataLoading: false,
  merchantTestCertificateHasError: false,

  merchantProdCertificateData: null,
  merchantProdCertificateDataLoading: false,
  merchantProdCertificateHasError: false,

  businessTypeRequiredFields: null,
  businessTypeRequiredFieldsLoading: false,
  businessTypeRequiredFieldsHasError: false,

  saveUploadedFileMetadataLoading: false,
  updateUploadedFileMetadataLoading: false,


  listOfMerchantCredentials: [],
  listOfMerchantCredentialsLoading: false,
  listOfMerchantCredentialsHasError: false,
  listOfMerchantCredentialsPagination: null,
  listOfMerchantCredentialsFilter: null,

  listOfMerchantCertificates: [],
  listOfMerchantCertificatesIsLoading: false,
  listOfMerchantCertificatesHasError: false,
  listOfMerchantCertificatesPagination: null,
  listOfMerchantCertificatesFilter: null,

  loadMoreMerchantCredentialLoading: false,
  merchantDetailsApiMessage: null,

  merchantCredentialByIdData: null,
  merchantCredentialByIdDataIsLoading: false,
  merchantCredentialByIdDataHasError: false,
  merchantCredentialByIdDataFilter: null,

  merchantCredentialPaymentChannels: null,
  merchantCredentialPaymentChannelsIsLoading: false,
  merchantCredentialPaymentChannelsHasError: false,
  merchantCredentialPaymentChannelsFilter: null,

  midAuditLogs: [],
  midAuditLogsIsLoading: false,
  midAuditLogsHasError: false,
  midAuditLogsPagination: null,
  midAuditLogsFilter: null,

  loadingMoreMidAuditLogs: false,

  companyProfileData: null,
  companyProfileDataLoading: false,
  companyProfileDataCache: {},
  companyProfileDataPagination: null,
  companyProfileDataFilter: {}
};

export default function merchantReducer(state = initState, action) {
  switch (action.type) {
    case actions.RESET_ERROR_MESSAGE:
      return {
        ...state,
        resetErrorMessage: action.payload,
        resetError: action.isError
      };
    case actions.RESETTING_TOKEN_DATA:
      return {
        ...state,
        resettingTokenData: true
      };
    case actions.RESET_TOKEN_DATA_SUCCESS:
      return {
        ...state,
        resettingTokenData: false,
        hasResetTokenData: action.result
      };
    case actions.RESET_TOKEN_DATA_FAILED:
      return {
        ...state,
        resettingTokenData: false,
        hasResetTokenData: null
      };
    case actions.NEW_RESETTING_MERCHANT_USER_PASSWORD:
      return {
        ...state,
        resettingMerchantUserPassword: true
      };

    case actions.NEW_MERCHANT_USER_PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        merchantPasswordResetData: action.result,
        newMerchantUserPasswordReset: true
      };

    case actions.NEW_MERCHANT_USER_PASSWORD_RESET_FAILED:
      return {
        ...state,
        resetErrorMessage: `Couldn't reset password. Please contact Administrator`,
        resetError: true,
        resettingMerchantUserPassword: false,
        newMerchantUserPasswordReset: false
      };
    case actions.CLEAR_MESSAGE:
      return {
        ...state,
        errorMessage: null,
        isError: false,
        pchannelError: false
      };

    case actions.FETCHING_MERCHANT_DATA:
      return {
        ...state,
        merchantData: null,
        pageLoading: action.loading,
        merchantLoading: action.loading
      };

    case actions.LOADING_MORE_MERCHANT_DATA:
      return {
        ...state,
        merchantDataLoadMore: true
      };

    case actions.FETCH_MERCHANT_DATA_SUCCESS:
      return {
        ...state,
        merchantLoading: action.loading,
        merchantFilter: action.filter,
        pageLoading: action.loading,
        merchantData: action.result,
        isError: false,
        merchantDataPagination: action.pagination,
        merchantDataLoadMore: false
      };

    case actions.FETCH_MERCHANT_DATA_FAILED:
      return {
        ...state,
        merchantLoading: action.loading,
        merchantFilter: null,
        pageLoading: action.loading,
        merchantData: action.result,
        isError: true,
        merchantDataLoadMore: false
      };

    case actions.RESET_MERCHANT_LIST:
      return {
        ...state,
        merchantLoading: false,
        merchantFilter: null,
        pageLoading: false,
        merchantData: null,
        isError: false,
        merchantDataLoadMore: false
      };

    case actions.FETCHING_MERCHANT_FILES:
      return {
        ...state,
        merchantFiles: null,
        pageLoading: action.loading,
        merchantFilesLoading: true
      };

    case actions.LOADING_MORE_MERCHANT_FILES:
      return {
        ...state,
        merchantFilesLoadMore: true
      };

    case actions.FETCH_MERCHANT_FILES_SUCCESS:
      return {
        ...state,
        merchantFilesLoading: false,
        merchantFilesFilter: action.filter,
        pageLoading: false,
        merchantFiles: action.result,
        isError: false,
        merchantFilesPagination: action.pagination,
        merchantFilesLoadMore: false
      };

    case actions.FETCH_MERCHANT_FILES_FAILED:
      return {
        ...state,
        merchantFilesLoading: false,
        merchantFilesFilter: null,
        pageLoading: action.loading,
        merchantFiles: action.result,
        isError: true,
        merchantFilesLoadMore: false
      };

    case actions.RESET_MERCHANT_FILES:
      return {
        ...state,
        merchantFilesLoading: false,
        merchantFilesFilter: null,
        pageLoading: false,
        merchantFiles: null,
        isError: false,
        merchantFilesLoadMore: false
      };

    case actions.FETCHING_PTI_TEST_MERCHANT_USERS:
      return {
        ...state,
        ptiTestMerchantUsersData: null,
        pageLoading: action.loading,
        ptiTestMerchantUsersLoading: action.loading
      };

    case actions.LOADING_MORE_PTI_TEST_MERCHANT_USERS:
      return {
        ...state,
        ptiTestMerchantUsersLoadMore: true
      };

    case actions.FETCH_PTI_TEST_MERCHANT_USERS_SUCCESS:
      return {
        ...state,
        ptiTestMerchantUsersLoading: action.loading,
        ptiTestMerchantUsersFilter: action.filter,
        pageLoading: action.loading,
        ptiTestMerchantUsersData: action.result,
        ptiTestMerchantUsersIsError: false,
        ptiTestMerchantUsersPagination: action.pagination,
        ptiTestMerchantUsersLoadMore: false
      };

    case actions.RESET_PTI_TEST_MERCHANT_USERS:
      return {
        ...state,
        ptiTestMerchantUsersLoading: false,
        ptiTestMerchantUsersFilter: null,
        pageLoading: false,
        ptiTestMerchantUsersData: null,
        ptiTestMerchantUsersIsError: false,
        ptiTestMerchantUsersPagination: null,
        ptiTestMerchantUsersLoadMore: false
      };

    case actions.FETCH_PTI_TEST_MERCHANT_USERS_FAILED:
      return {
        ...state,
        ptiTestMerchantUsersLoading: action.loading,
        ptiTestMerchantUsersFilter: null,
        pageLoading: action.loading,
        ptiTestMerchantUsersData: action.result,
        ptiTestMerchantUsersIsError: true,
        ptiTestMerchantUsersLoadMore: false
      };

    case actions.FETCHING_PTI_PROD_MERCHANT_USERS:
      return {
        ...state,
        ptiProdMerchantUsersData: null,
        pageLoading: action.loading,
        ptiProdMerchantUsersLoading: action.loading
      };

    case actions.LOADING_MORE_PTI_PROD_MERCHANT_USERS:
      return {
        ...state,
        ptiProdMerchantUsersLoadMore: true
      };

    case actions.FETCHING_PTI_MERCHANT_USERS:
      return {
        ...state,
        ptiMerchantUserDataIsLoading: action.loading
      };

    case actions.FETCH_PTI_MERCHANT_USERS_SUCCESS:
      return {
        ...state,
        ptiMerchantUserDataIsLoading: action.loading,
        ptiMerchantUserDataHasError: false,
        ptiMerchantUserData: action.result,
        ptiMerchantUserDataFilter: action.filter,
        ptiMerchantUserDataPagination: action.pagination,
        ptiMerchantUserDataLoadMore: false
      };

    case actions.FETCH_PTI_MERCHANT_USERS_FAILED:
      return {
        ...state,
        ptiMerchantUserDataIsLoading: action.loading,
        ptiMerchantUserDataHasError: true
      };

    case actions.LOADING_MORE_PTI_MERCHANT_USERS:
      return {
        ...state,
        ptiMerchantUserDataLoadMore: true
      };

    case actions.FETCH_PTI_PROD_MERCHANT_USERS_SUCCESS:
      return {
        ...state,
        ptiProdMerchantUsersLoading: action.loading,
        ptiProdMerchantUsersFilter: action.filter,
        pageLoading: action.loading,
        ptiProdMerchantUsersData: action.result,
        ptiProdMerchantUsersIsError: false,
        ptiProdMerchantUsersPagination: action.pagination,
        ptiProdMerchantUsersLoadMore: false
      };

    case actions.RESET_PTI_PROD_MERCHANT_USERS:
      return {
        ...state,
        ptiProdMerchantUsersLoading: false,
        ptiProdMerchantUsersFilter: null,
        pageLoading: false,
        ptiProdMerchantUsersData: null,
        ptiProdMerchantUsersIsError: false,
        ptiProdMerchantUsersPagination: null,
        ptiProdMerchantUsersLoadMore: false
      };

    case actions.FETCH_PTI_PROD_MERCHANT_USERS_FAILED:
      return {
        ...state,
        ptiProdMerchantUsersLoading: action.loading,
        ptiProdMerchantUsersFilter: null,
        pageLoading: action.loading,
        ptiProdMerchantUsersData: action.result,
        ptiProdMerchantUsersIsError: true,
        ptiProdMerchantUsersLoadMore: false
      };

    case actions.FETCHING_MERCHANT_AMOUNT_LEVEL_DATA:
      return {
        ...state,
        amountLevelData: null,
        amountLevelLoading: action.loading
      };

    case actions.FETCH_MERCHANT_AMOUNT_LEVEL_DATA_SUCCESS:
      return {
        ...state,
        amountLevelLoading: action.loading,
        amountLevelData: action.result,
        amountLevelError: false
      };

    case actions.FETCH_MERCHANT_AMOUNT_LEVEL_DATA_FAILED:
      return {
        ...state,
        amountLevelLoading: action.loading,
        amountLevelData: action.result,
        amountLevelError: true
      };

    case actions.FETCHING_ELASTIC_MERCHANT_DATA:
      return {
        ...state,
        elasticMerchantData: null,
        pageLoading: action.loading,
        elasticMerchantLoading: action.loading
      };

    case actions.FETCH_ELASTIC_MERCHANT_DATA_SUCCESS:
      return {
        ...state,
        elasticMerchantLoading: action.loading,
        pageLoading: action.loading,
        elasticMerchantData: action.result,
        isError: false
      };

    case actions.FETCH_ELASTIC_MERCHANT_DATA_FAILED:
      return {
        ...state,
        elasticMerchantLoading: action.loading,
        pageLoading: action.loading,
        elasticMerchantData: action.result,
        isError: true
      };

    case actions.FETCHING_MERCHANT_DATA_BY_ID:
      return {
        ...state,
        activeMerchant: null,
        pageLoading: action.loading,
        activeMerchantLoading: true
      };

    case actions.FETCH_MERCHANT_DATA_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeMerchantLoading: false,
        activeMerchant: action.result,
        listOfMerchantCredentials: action.result?.merchant_credentials?.data ?? [],
        listOfMerchantCredentialsPagination: action.result?.merchant_credentials?.total
          ? { page: 0, limit: 4, total: action.result?.merchant_credentials?.total }
          : null,
        listOfMerchantCredentialsFilter: actions.result?.id ? actions.result?.id : '',
        isError: false
      };

    case actions.FETCH_MERCHANT_DATA_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeMerchant: null,
        isError: true,
        activeMerchantLoading: false
      };

    case actions.FETCHING_MERCHANT_CREDENTIALS:
      return {
        ...state,
        listOfMerchantCredentials: [],
        listOfMerchantCredentialsLoading: action.loading
      };

    case actions.FETCH_MERCHANT_CREDENTIALS_SUCCESS:
      return {
        ...state,
        listOfMerchantCredentialsLoading: action.loading,
        listOfMerchantCredentials: action.result,
        listOfMerchantCredentialsHasError: false,
        listOfMerchantCredentialsPagination: action.pagination,
        listOfMerchantCredentialsFilter: action.filter,
        merchantDetailsApiMessage: action.message
      };

    case actions.FETCH_MERCHANT_CREDENTIALS_FAILED:
      return {
        ...state,
        listOfMerchantCredentialsLoading: action.loading,
        listOfMerchantCredentialsHasError: true,
        listOfMerchantCredentialsPagination: { page: 0, limit: 4, total: 0 },
        merchantDetailsApiMessage: action.message
      };

    case actions.LOADING_MORE_MERCHANT_CREDENTIALS:
      return {
        ...state,
        loadMoreMerchantCredentialLoading: action.loading
      };

    case actions.LOAD_MORE_MERCHANT_CREDENTIALS_SUCCESS:
      return {
        ...state,
        loadMoreMerchantCredentialLoading: action.loading,
        listOfMerchantCredentials: [...state.listOfMerchantCredentials, ...action.result],
        listOfMerchantCredentialsPagination: action.pagination,
        listOfMerchantCredentialsFilter: action.filter,
        listOfMerchantCredentialsHasError: false,
        merchantDetailsApiMessage: action.message
      };

    case actions.LOAD_MORE_MERCHANT_CREDENTIALS_FAILED:
      return {
        ...state,
        loadMoreMerchantCredentialLoading: false,
        listOfMerchantCredentialsHasError: true,
        listOfMerchantCredentialsPagination: { page: 0, limit: 4, total: 0 },
        merchantDetailsApiMessage: action.message
      };

    case actions.ADDING_NEW_MERCHANT_CERTIFICATE:
      return {
        ...state,
        listOfMerchantCertificatesIsLoading: action.loading
      };

    case actions.ADD_NEW_MERCHANT_CERTIFICATE_SUCCESS: {
      //Take note: if there would be more than 3 and have pagination apply this
      // const currentList = state.listOfMerchantCertificates;
      // const currentTotal = state.listOfMerchantCertificatesPagination?.total;

      // const isListFull = currentTotal === currentList.length;

      // const updatedList = isListFull
      //   ? [action.result, ...currentList.slice(0, -1)]
      //   : [action.result, ...currentList];
      return {
        ...state,
        listOfMerchantCertificates: [action.result, ...state.listOfMerchantCertificates],
        listOfMerchantCertificatesPagination: {
          ...state.listOfMerchantCertificatesPagination,
          total: (state.listOfMerchantCertificatesPagination?.total ?? 0) + 1
        },
        listOfMerchantCertificatesHasError: false,
        listOfMerchantCertificatesIsLoading: action.loading,
        merchantDetailsApiMessage: action.message
      };
    }
    case actions.ADD_NEW_MERCHANT_CERTIFICATE_FAILED:
      return {
        ...state,
        listOfMerchantCertificatesHasError: true,
        listOfMerchantCertificatesIsLoading: action.loading,
        merchantDetailsApiMessage: action.message
      };

    case actions.UPDATING_MERCHANT_CERTIFICATE_V2:
      return {
        ...state,
        listOfMerchantCertificatesIsLoading: action.loading
      };

    case actions.UPDATE_MERCHANT_CERTIFICATE_V2_SUCCESS: {
      //Remove the updated list
      const currentList = state.listOfMerchantCertificates;
      const removeOutDatedDataList = currentList.filter(
        certificate => certificate.id !== action.result.id
      );

      return {
        ...state,
        listOfMerchantCertificates: [action.result, ...removeOutDatedDataList],
        listOfMerchantCertificatesHasError: false,
        listOfMerchantCertificatesIsLoading: action.loading,
        merchantDetailsApiMessage: action.message
      };
    }

    case actions.UPDATE_MERCHANT_CERTIFICATE_V2_FAILED:
      return {
        ...state,
        listOfMerchantCertificatesHasError: false,
        listOfMerchantCertificatesIsLoading: action.loading,
        merchantDetailsApiMessage: action.message
      };

    case actions.UPDATING_MID_CERTIFICATE:
      return {
        ...state,
        listOfMerchantCertificatesIsLoading: action.loading
      };

    case actions.UPDATE_MID_CERTIFICATE_SUCCESS:
      return {
        ...state,
        listOfMerchantCertificatesHasError: false,
        listOfMerchantCertificatesIsLoading: action.loading,
        merchantDetailsApiMessage: action.message
      };

    case actions.UPDATE_MID_CERTIFICATE_FAILED:
      return {
        ...state,
        listOfMerchantCertificatesHasError: true,
        listOfMerchantCertificatesIsLoading: action.loading,
        merchantDetailsApiMessage: action.message
      };
    case actions.FETCHING_MERCHANT_CERTIFICATES:
      return {
        ...state,
        listOfMerchantCertificatesIsLoading: action.loading
      };

    case actions.FETCH_MERCHANT_CERTIFICATES_SUCCESS:
      return {
        ...state,
        listOfMerchantCertificates: [...action.result],
        listOfMerchantCertificatesFilter: action.filter,
        listOfMerchantCertificatesPagination: action.pagination,
        listOfMerchantCertificatesHasError: false,
        listOfMerchantCertificatesIsLoading: action.loading,
        merchantDetailsApiMessage: action.message
      };

    case actions.FETCH_MERCHANT_CERTIFICATES_FAILED:
      return {
        ...state,
        listOfMerchantCertificatesHasError: true,
        listOfMerchantCertificatesIsLoading: action.loading,
        merchantDetailsApiMessage: action.message
      };

    case actions.RESET_MERCHANT_CREDENTIALS:
      return {
        ...state,
        listOfMerchantCredentials: [],
        listOfMerchantCredentialsPagination: { total: 0, page: 0, limit: 4 },
        listOfMerchantCredentialsFilter: null
      };

    case actions.RESET_MERCHANT_CERTIFICATES:
      return {
        ...state,
        listOfMerchantCertificates: [],
        listOfMerchantCertificatesFilter: null,
        listOfMerchantCertificatesPagination: null,
        listOfMerchantCertificatesIsLoading: false,
        listOfMerchantCertificatesHasError: false
      };

    case actions.FETCHING_MERCHANT_CREDENTIAL_BY_ID:
      return {
        ...state,
        merchantCredentialByIdDataIsLoading: action.loading
      };

    case actions.FETCH_MERCHANT_CREDENTIAL_BY_ID_SUCCESS:
      return {
        ...state,
        merchantCredentialByIdDataIsLoading: action.loading,
        merchantCredentialByIdDataHasError: false,
        merchantCredentialByIdDataFilter: action.filter,
        merchantCredentialByIdData: action.result,
        merchantDetailsApiMessage: action.message
      };

    case actions.FETCH_MERCHANT_CREDENTIAL_BY_ID_FAILED:
      return {
        ...state,
        merchantCredentialByIdDataIsLoading: action.loading,
        merchantCredentialByIdDataHasError: true,
        merchantDetailsApiMessage: action.message
      };

    case actions.FETCHING_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID:
      return {
        ...state,
        merchantCredentialPaymentChannelsIsLoading: action.loading
      };

    case actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID_SUCCESS:
      return {
        ...state,
        merchantCredentialPaymentChannelsIsLoading: action.loading,
        merchantCredentialPaymentChannels: action.result,
        merchantCredentialPaymentChannelsHasError: false,
        merchantCredentialPaymentChannelsFilter: action.payload,
        merchantDetailsApiMessage: action.message
      };

    case actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_MID_FAILED:
      return {
        ...state,
        merchantCredentialPaymentChannelsIsLoading: action.loading,
        merchantCredentialPaymentChannelsHasError: true,
        merchantDetailsApiMessage: action.message
      };

    case actions.UPDATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID:
      return {
        ...state,
        merchantCredentialPaymentChannelsIsLoading: action.loading
      };

    case actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_SUCCESS: {
      const filterMerchantPaymentChannels = state.merchantCredentialPaymentChannels.filter(
        pChannel => pChannel?.id !== action?.result?.id
      );

      return {
        ...state,
        merchantCredentialPaymentChannelsIsLoading: action.loading,
        merchantCredentialPaymentChannelsHasError: false,
        merchantDetailsApiMessage: action.message,
        merchantCredentialPaymentChannels: [action.result, ...filterMerchantPaymentChannels]
      };
    }

    case actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_FAILED:
      return {
        ...state,
        merchantCredentialPaymentChannelsIsLoading: action.loading,
        merchantCredentialPaymentChannelsHasError: true,
        merchantDetailsApiMessage: action.message
      };

    case actions.UPDATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS:
      return {
        ...state,
        merchantCredentialPaymentChannelsIsLoading: action.loading
      };

    case actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS_SUCCESS: {
      const filterMerchantPaymentChannels = state.merchantCredentialPaymentChannels.filter(
        pChannel => pChannel?.id !== action?.result?.id
      );

      return {
        ...state,
        merchantCredentialPaymentChannelsIsLoading: action.loading,
        merchantCredentialPaymentChannelsHasError: false,
        merchantDetailsApiMessage: action.message,
        merchantCredentialPaymentChannels: [action.result, ...filterMerchantPaymentChannels]
      };
    }

    case actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_STATUS_FAILED:
      return {
        ...state,
        merchantCredentialPaymentChannelsIsLoading: action.loading,
        merchantCredentialPaymentChannelsHasError: true,
        merchantDetailsApiMessage: action.message
      };

    case actions.MIGRATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID:
      return {
        ...state,
        merchantCredentialPaymentChannelsIsLoading: action.loading
      };

    case actions.MIGRATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_SUCCESS:
      const filterMerchantPaymentChannels = state.merchantCredentialPaymentChannels.filter(
        pChannel => pChannel?.id !== action?.result?.id
      );

      return {
        ...state,
        merchantCredentialPaymentChannelsIsLoading: action.loading,
        merchantCredentialPaymentChannelsHasError: false,
        merchantDetailsApiMessage: action.message,
        merchantCredentialPaymentChannels: [action.result, ...filterMerchantPaymentChannels]
      };

    case actions.MIGRATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_BY_MID_FAILED:
      return {
        ...state,
        merchantCredentialPaymentChannelsIsLoading: action.loading,
        merchantCredentialPaymentChannelsHasError: true,
        merchantDetailsApiMessage: action.message
      };

    case actions.RESET_MERCHANT_CREDENTIAL_BY_ID:
      return {
        ...state,
        merchantCredentialByIdDataHasError: false,
        merchantCredentialByIdDataIsLoading: false,
        merchantDetailsApiMessage: null,
        merchantCredentialByIdData: null,
        merchantCredentialByIdDataFilter: null,
        merchantCredentialPaymentChannelsHasError: false,
        merchantCredentialPaymentChannelsFilter: null,
        merchantCredentialPaymentChannels: null,
        midAuditLogs: null,
        midAuditLogsFilter: null,
        midAuditLogsPagination: null
      };
    case actions.CLEAR_MERCHANT_DETAILS_MESSAGE:
      return {
        ...state,
        listOfMerchantCertificatesHasError: false,
        listOfMerchantCredentialsHasError: false,
        merchantCredentialPaymentChannelsHasError: false,
        merchantCredentialByIdDataHasError: false,
        merchantDetailsApiMessage: null
      };

    case actions.LOADING_MORE_MERCHANT_AUDIT_LOGS:
      return {
        ...state,
        merchantProfileLogsLoadMore: action.loading
      };
    case actions.LOAD_MORE_MERCHANT_AUDIT_LOGS_SUCCESS: {
      const mergedLogs = [...state.merchantProfileLogsData, ...action.result];

      const uniqueLogs = Array.from(new Map(mergedLogs.map(log => [log.id, log])).values());

      return {
        ...state,
        merchantProfileLogsLoadMore: action.loading,
        merchantProfileLogsData: uniqueLogs,
        merchantProfileLogsIsError: false,
        merchantProfileLogsPagination: action.pagination
      };
    }
    case actions.LOAD_MORE_MERCHANT_AUDIT_LOGS_FAILED:
      return {
        ...state,
        merchantProfileLogsIsError: false,
        merchantProfileLogsLoadMore: action.loading
      };

    case actions.FETCHING_MID_AUDIT_LOGS:
      return {
        ...state,
        midAuditLogsIsLoading: action.loading
      };

    case actions.FETCH_MID_AUDIT_LOGS_SUCCESS:
      return {
        ...state,
        midAuditLogsIsLoading: action.loading,
        midAuditLogsHasError: false,
        midAuditLogs: action?.result ?? [],
        midAuditLogsPagination: action.pagination,
        midAuditLogsFilter: action.filter
      };

    case actions.FETCH_MID_AUDIT_LOGS_FAILED:
      return {
        ...state,
        midAuditLogsIsLoading: action.loading,
        midAuditLogsHasError: true
      };

    case actions.LOADING_MORE_MID_AUDIT_LOGS:
      return {
        ...state,
        loadingMoreMidAuditLogs: action.loading
      };

    case actions.LOAD_MORE_MID_AUDIT_LOGS_SUCCESS: {
      const mergedLogs = [...state.midAuditLogs, ...action.result];
      const uniqueLogs = Array.from(new Map(mergedLogs.map(log => [log.id, log])).values());
      return {
        ...state,
        loadingMoreMidAuditLogs: action.loading,
        midAuditLogsHasError: false,
        midAuditLogs: uniqueLogs,
        midAuditLogsPagination: action.pagination
      };
    }

    case actions.LOAD_MORE_MID_AUDIT_LOGS_FAILED:
      return {
        ...state,
        midAuditLogsHasError: true,
        loadingMoreMidAuditLogs: action.loading
      };

    //For Synching Updated Logs after action done
    case actions.UPDATE_AUDIT_LOGS:
      return {
        ...state,
        midAuditLogs: [action.log, ...state.midAuditLogs],
        merchantProfileLogsData: [action.log, ...state.merchantProfileLogsData],
        midAuditLogsPagination: {
          ...state.midAuditLogsPagination,
          total: state.midAuditLogsPagination.total + 1
        },
        merchantProfileLogsPagination: {
          ...state.merchantProfileLogsPagination,
          total: state.merchantProfileLogsPagination.total + 1
        }
      };

    case actions.FETCHING_PAYBIZ_DETAILS_BY_ID:
      return {
        ...state,
        paybizDetailsLoading: action.loading
      };

    case actions.FETCH_PAYBIZ_DETAILS_BY_ID_SUCCESS:
      return {
        ...state,
        paybizDetailsLoading: action.loading,
        paybizDetails: action.result,
        paybizDetailsHasError: false
      };

    case actions.FETCH_PAYBIZ_DETAILS_BY_ID_FAILED:
      return {
        ...state,
        paybizDetailsLoading: action.loading,
        paybizDetails: null,
        paybizDetailsHasError: true
      };

    case actions.RESET_PAYBIZ_DETAILS:
      return {
        ...state,
        paybizDetailsLoading: false,
        paybizDetailsHasError: false,
        paybizDetails: null
      };

    case actions.FETCHING_PAYBIZ_MERCHANTS:
      return {
        ...state,
        paybizMerchantsLoading: action.loading
      };

    case actions.FETCH_PAYBIZ_MERCHANTS_SUCCESS:
      return {
        ...state,
        paybizMerchantsLoading: action.loading,
        paybizMerchants: action.result,
        paybizMerchantsHasError: false,
        paybizMerchantFilter: action.filter,
        paybizMerchantsTotalCount: action.total
      };

    case actions.FETCH_PAYBIZ_MERCHANTS_FAILED:
      return {
        ...state,
        paybizMerchantsLoading: action.loading,
        paybizMerchants: null,
        paybizMerchantsHasError: true
      };

    case actions.FETCHING_MERCHANT_PCHANNEL_DATA_BY_ID:
      return {
        ...state,
        merchantPchannels: null,
        pageLoading: action.loading,
        merchantPchannelsLoading: true
      };

    case actions.FETCH_MERCHANT_PCHANNEL_DATA_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        merchantPchannels: action.result,
        merchantPchannelsLoading: false,
        pchannelError: false,
        errorMessage: null
      };

    case actions.FETCH_MERCHANT_PCHANNEL_DATA_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        merchantPchannels: null,
        merchantPchannelsLoading: false,
        pchannelError: true,
        errorMessage: action.message
      };
    case actions.RESET_MERCHANT_PCHANNEL_DATA:
      return {
        ...state,
        merchantPchannels: null,
        pchannelError: false,
        errorMessage: null
      };

    case actions.FETCHING_MERCHANT_LOGS_DATA_BY_ID:
      return {
        ...state,
        merchantLogs: null,
        pageLoading: action.loading
      };

    case actions.FETCH_MERCHANT_LOGS_DATA_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        merchantLogs: action.result,
        merchantLogsPagination: action.pagination,
        logsError: false
      };

    case actions.FETCH_MERCHANT_LOGS_DATA_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        merchantLogs: null,
        merchantLogsPagination: null,
        logsError: true
      };
    case actions.RESET_MERCHANT_LOGS_DATA:
      return {
        ...state,
        merchantLogs: null,
        merchantLogsPagination: null,
        pageLoading: false
      };

    case actions.RESET_MERCHANT_DATA:
      return {
        ...state,
        activeMerchant: null,
        pageLoading: false
      };

    case actions.RESET_MERCHANT_INFORMATION_DATA:
      return {
        ...state,
        activeMerchantInformation: null
      };

    case actions.ADDING_MERCHANT_DATA:
      return {
        ...state,
        isError: false,
        merchantLoading: true,
        pageLoading: true
      };

    case actions.ADD_MERCHANT_DATA_SUCCESS:
      return {
        ...state,
        merchantLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_MERCHANT_DATA_FAILED:
      return {
        ...state,
        merchantLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.ADDING_PTI_DASHBOARD_USER:
      return {
        ...state,
        ptiMerchantUserDataIsLoading: action.loading
      };

    // case actions.FETCHING_PTI_MERCHANT_USERS:
    //   return {
    //     ...state,
    //     ptiMerchantUserDataIsLoading: action.loading
    //   };

    // case actions.FETCH_PTI_MERCHANT_USERS_SUCCESS:
    //   return {
    //     ...state,
    //     ptiMerchantUserDataIsLoading: action.loading,
    //     ptiMerchantUserDataHasError: false,
    //     ptiMerchantUserData: action.result,
    //     ptiMerchantUserDataFilter: action.filter,
    //     ptiMerchantUserDataPagination: action.pagination,
    //     ptiMerchantUserDataLoadMore: false
    //   };

    // case actions.FETCH_PTI_MERCHANT_USERS_FAILED:
    //   return {
    //     ...state,
    //     ptiMerchantUserDataIsLoading: action.loading,
    //     ptiMerchantUserDataHasError: true
    //   };

    case actions.ADD_PTI_DASHBOARD_USER_SUCCESS:
      return {
        ...state,
        ptiMerchantUserDataIsLoading: action.loading,
        ptiMerchantUserData: action.result,
        ptiMerchantUserDataHasError: false,
        ptiMerchantUserDataPagination: {
          ...state.ptiMerchantUserDataPagination,
          total: state.ptiMerchantUserDataPagination.total + action.email_added
        }
      };

    case actions.ADD_PTI_DASHBOARD_USER_FAILED:
      return {
        ...state,
        ptiMerchantUserDataIsLoading: action.loading,
        ptiMerchantUserData: action.result,
        ptiMerchantUserDataHasError: true
      };

    case actions.UPDATING_PTI_DASHBOARD_USER:
      return {
        ...state,
        ptiMerchantUserDataIsLoading: action.loading
      };

    case actions.UPDATE_PTI_DASHBOARD_USER_SUCCESS:
      return {
        ...state,
        ptiMerchantUserDataIsLoading: action.loading,
        ptiMerchantUserData: action.result,
        ptiMerchantUserDataHasError: false
      };

    case actions.UPDATE_PTI_DASHBOARD_USER_FAILED:
      return {
        ...state,
        ptiMerchantUserDataIsLoading: action.loading,
        ptiMerchantUserDataHasError: true
      };

    case actions.REGISTERING_PTI_DASHBOARD_USER:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading,
        signUpUserStatus: false
      };

    case actions.REGISTER_PTI_DASHBOARD_USER_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        signUpUserStatus: true
      };

    case actions.REGISTER_PTI_DASHBOARD_USER_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading,
        signUpUserStatus: false
      };

    case actions.FETCHING_INVITED_MERCHANT_USER_DATA:
      return {
        ...state,
        invitedMerchantUserData: null,
        invitedMerchantUserLoading: action.loading
      };

    case actions.FETCH_INVITED_MERCHANT_USER_DATA_SUCCESS:
      return {
        ...state,
        invitedMerchantUserLoading: action.loading,
        invitedMerchantUserData: action.result,
        invitedMerchantUserIsError: false
      };

    case actions.FETCH_INVITED_MERCHANT_USER_DATA_FAILED:
      return {
        ...state,
        invitedMerchantUserLoading: action.loading,
        invitedMerchantUserData: action.result,
        invitedMerchantUserIsError: true
      };

    case actions.ADDING_MERCHANT_INFORMATION:
      return {
        ...state,
        isError: false,
        merchantInformationLoading: true,
        pageLoading: true
      };

    case actions.ADD_MERCHANT_INFORMATION_SUCCESS:
      return {
        ...state,
        merchantInformationLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_MERCHANT_INFORMATION_FAILED:
      return {
        ...state,
        merchantInformationLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.FETCHING_ALL_MERCHANT_INFORMATION:
      return {
        ...state,
        merchantInformation: null,
        pageLoading: action.loading,
        merchantInformationLoading: action.loading
      };

    case actions.FETCH_ALL_MERCHANT_INFORMATION_SUCCESS:
      return {
        ...state,
        merchantInformationLoading: action.loading,
        pageLoading: action.loading,
        merchantInformation: action.result,
        merchantFilter: action.filter,
        isError: false
      };

    case actions.FETCH_ALL_MERCHANT_INFORMATION_FAILED:
      return {
        ...state,
        merchantInformationLoading: action.loading,
        pageLoading: action.loading,
        merchantInformation: action.result,
        isError: true
      };

    case actions.FETCHING_MERCHANT_INFO_BY_ID:
      return {
        ...state,
        activeMerchantInformation: null,
        pageLoading: action.loading
      };

    case actions.FETCH_MERCHANT_INFO_BY_ID_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeMerchantInformation: action.result,
        isError: false
      };

    case actions.FETCH_MERCHANT_INFO_BY_ID_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeMerchantInformation: null,
        isError: true
      };

    case actions.EDITING_MERCHANT_INFO:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        merchantInformationLoading: true
      };

    case actions.EDIT_MERCHANT_INFO_SUCCESS:
      return {
        ...state,
        merchantInformationLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.EDIT_MERCHANT_INFO_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        merchantInformationLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.INVITING_MERCHANT_DATA:
      return {
        ...state,
        isError: false,
        merchantLoading: true,
        pageLoading: action.loading
      };

    case actions.INVITE_MERCHANT_DATA_SUCCESS:
      return {
        ...state,
        merchantLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading
      };

    case actions.INVITE_MERCHANT_DATA_FAILED:
      return {
        ...state,
        merchantLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.FETCHING_INVITED_MERCHANT_DATA:
      return {
        ...state,
        invitedMerchantData: null,
        invitedMerchantDataLoading: action.loading
      };

    case actions.FETCH_INVITED_MERCHANT_DATA_SUCCESS:
      return {
        ...state,
        invitedMerchantData: action.result,
        invitedMerchantDataLoading: action.loading,
        invitedMerchantDataIsError: false
      };

    case actions.FETCH_INVITED_MERCHANT_DATA_FAILED:
      return {
        ...state,
        invitedMerchantData: action.result,
        invitedMerchantDataLoading: action.loading,
        invitedMerchantDataIsError: true
      };

    case (actions.LOGGING_ACCESS_INVITE_DATA, actions.LOGGING_ACCESS_MIS):
      return {
        ...state,
        isError: false,
        logAccessLoading: true,
        pageLoading: action.loading
      };

    case (actions.LOG_ACCESS_INVITE_DATA_SUCCESS, actions.LOG_ACCESS_MIS_SUCCESS):
      return {
        ...state,
        logAccessLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading
      };

    case (actions.LOG_ACCESS_INVITE_DATA_FAILED, actions.LOG_ACCESS_MIS_FAILED):
      return {
        ...state,
        logAccessLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.EDITING_MIGRATED_MID:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        merchantLoading: true
      };

    case actions.EDIT_MIGRATED_MID_SUCCESS:
      const newMid = action.merchant_id;

      const parentMids = state?.merchantInfoMIDs?.parent_mid?.map(mid => ({
        ...mid,
        merchant_id: newMid
      }));

      const newMerchantData = state?.merchantData?.map(merchant =>
        merchant?.id === action.merchant_management_id
          ? { ...merchant, merchant_id: newMid, mid: newMid }
          : merchant
      );

      return {
        ...state,
        merchantLoading: false,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        merchantInfoMIDs: { ...state?.merchantInfoMIDs, parent_mid: parentMids },
        merchantData: newMerchantData,
        activeMerchantInformation: {
          ...state?.activeMerchantInformation,
          merchant_id: newMid,
          mid: newMid
        }
      };

    case actions.EDIT_MIGRATED_MID_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        merchantLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.EDITING_MERCHANT_BASIC_INFORMATION_DATA:
      return {
        ...state,
        isError: false,
        pageLoading: true,
        merchantLoading: true
      };

    case actions.EDIT_MERCHANT_BASIC_INFORMATION_DATA_SUCCESS:
      return {
        ...state,
        merchantLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        isError: false
      };

    case actions.EDIT_MERCHANT_BASIC_INFORMATION_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        merchantLoading: action.loading,
        isError: true,
        pageLoading: false
      };

    case actions.EDITING_MERCHANT_OWNER_INFORMATION_DATA:
      return {
        ...state,
        pageLoading: true,
        isError: false,
        merchantLoading: true
      };

    case actions.EDIT_MERCHANT_OWNER_INFORMATION_DATA_SUCCESS:
      return {
        ...state,
        merchantLoading: action.loading,
        pageLoading: false,
        errorMessage: action.message,
        isError: false,
        activeMerchant: null
      };

    case actions.EDIT_MERCHANT_OWNER_INFORMATION_DATA_FAILED:
      return {
        ...state,
        merchantLoading: action.loading,
        isError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.EDITING_MERCHANT_CONTACT_INFORMATION_DATA:
      return {
        ...state,
        merchantLoading: true,
        isError: false,
        pageLoading: true
      };

    case actions.EDIT_MERCHANT_CONTACT_INFORMATION_DATA_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        merchantLoading: action.loading,
        pageLoading: false,
        isError: false,
        activeMerchant: null
      };

    case actions.EDIT_MERCHANT_CONTACT_INFORMATION_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        merchantLoading: action.loading,
        isError: true
      };

    case actions.EDITING_MERCHANT_SERVICE_INFORMATION_DATA:
      return {
        ...state,
        pageLoading: true,
        merchantLoading: true,
        isError: false
      };

    case actions.EDIT_MERCHANT_SERVICE_INFORMATION_DATA_SUCCESS:
      return {
        ...state,
        merchantLoading: action.loading,
        isError: false,
        errorMessage: action.message,
        pageLoading: false,
        activeMerchant: null
      };

    case actions.EDIT_MERCHANT_SERVICE_INFORMATION_DATA_FAILED:
      return {
        ...state,
        merchantLoading: action.loading,
        pageLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.DELETING_MERCHANT_DATA:
      return {
        ...state,
        merchantLoading: true,
        pageLoading: true,
        isError: false
      };

    case actions.DELETE_MERCHANT_DATA_SUCCESS:
      return {
        ...state,
        merchantLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false,
        activeMerchant: null
      };

    case actions.DELETE_MERCHANT_DATA_FAILED:
      return {
        ...state,
        isError: true,
        errorMessage: action.message,
        merchantLoading: action.loading,
        pageLoading: false
      };

    case actions.FILTERING_MERCHANT:
      return {
        ...state,
        merchantLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.FILTER_MERCHANT_SUCCESS:
      return {
        ...state,
        merchantLoading: action.loading,
        merchantData: action.result,
        pageLoading: action.loading,
        isError: false
      };

    case actions.FILTER_MERCHANT_FAILED:
      return {
        ...state,
        merchantLoading: action.loading,
        pageLoading: action.loading,
        isError: true
      };
    case actions.FETCHING_PARENT_MERCHANT_DATA:
      return {
        ...state,
        merchantParentData: null,
        merchantParentLoading: action.loading
      };

    case actions.FETCH_PARENT_MERCHANT_DATA_SUCCESS:
      return {
        ...state,
        merchantParentLoading: action.loading,
        merchantParentData: action.result,
        merchantParentIsError: false
      };

    case actions.FETCH_PARENT_MERCHANT_DATA_FAILED:
      return {
        ...state,
        merchantParentLoading: action.loading,
        merchantParentData: action.result,
        merchantParentIsError: true
      };

    case actions.EDITING_MERCHANT_PCHANNEL_INFORMATION_DATA:
      return {
        ...state,
        pchannelError: false,
        pageLoading: true,
        merchantPchannelsLoading: true
      };

    case actions.EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA_SUCCESS:
      return {
        ...state,
        merchantPchannelsLoading: action.loading,
        errorMessage: action.message,
        pageLoading: false,
        pchannelError: false
      };

    case actions.EDIT_MERCHANT_PCHANNEL_INFORMATION_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        merchantPchannelsLoading: action.loading,
        pchannelError: true,
        pageLoading: false
      };

    case actions.FETCHING_FILE_MANAGEMENT_DATA:
      return {
        ...state,
        fileManagementData: null,
        fileManagementLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.FETCH_FILE_MANAGEMENT_DATA_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        fileManagementData: action.result,
        fileManagementPagination: action.pagination,
        fileManagementError: false,
        fileManagementLoading: action.loading
      };

    case actions.FETCH_FILE_MANAGEMENT_DATA_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        fileManagementData: null,
        fileManagementPagination: null,
        fileManagementError: true,
        fileManagementLoading: action.loading
      };
    case actions.RESET_FILE_MANAGEMENT_DATA:
      return {
        ...state,
        fileManagementData: null,
        fileManagementPagination: null,
        pageLoading: false,
        fileManagementLoading: false
      };
    case actions.UPLOADING_FILE_DATA:
      return {
        ...state,
        isFileError: false,
        fileLoading: true,
        pageLoading: true
      };

    case actions.UPLOAD_FILE_DATA_SUCCESS:
      return {
        ...state,
        fileLoading: action.loading,
        errorMessage: action.message,
        isFileError: false,
        pageLoading: false
      };

    case actions.UPLOAD_FILE_DATA_FAILED:
      return {
        ...state,
        fileLoading: action.loading,
        errorMessage: action.message,
        isFileError: true,
        pageLoading: false
      };
    case actions.DOWNLOADING_FILE_DATA:
      return {
        ...state,
        isFileError: false,
        fileLoading: true,
        pageLoading: true
      };

    case actions.DOWNLOAD_FILE_DATA_SUCCESS:
      return {
        ...state,
        fileLoading: action.loading,
        errorMessage: action.message,
        isFileError: false,
        pageLoading: false,
        fileDownloadData: action.payload
      };

    case actions.DOWNLOAD_FILE_DATA_FAILED:
      return {
        ...state,
        fileLoading: action.loading,
        errorMessage: action.message,
        isFileError: true,
        pageLoading: false,
        fileDownloadData: action.payload
      };
    case actions.DELETING_FILE_DATA:
      return {
        ...state,
        isFileError: false,
        fileLoading: true,
        pageLoading: true
      };

    case actions.DELETE_FILE_DATA_SUCCESS:
      return {
        ...state,
        fileLoading: action.loading,
        errorMessage: action.message,
        isFileError: false,
        pageLoading: false
      };

    case actions.DELETE_FILE_DATA_FAILED:
      return {
        ...state,
        fileLoading: action.loading,
        errorMessage: action.message,
        isFileError: true,
        pageLoading: false
      };

    case actions.REMOVE_FILE_DATA_STORAGE:
      return {
        ...state,
        fileLoading: action.loading,
        pageLoading: false,
        fileDownloadData: action.payload
      };

    case actions.FETCHING_MERCHANT_CONFIG_DATA:
      return {
        ...state,
        merchantConfigurationData: null,
        merchantConfigurationLoading: true
      };

    case actions.FETCH_MERCHANT_CONFIG_DATA_SUCCESS:
      return {
        ...state,
        merchantConfigurationLoading: false,
        merchantConfigurationData: action.result,
        merchantConfigurationIsError: false
      };

    case actions.FETCH_MERCHANT_CONFIG_DATA_FAILED:
      return {
        ...state,
        merchantConfigurationLoading: false,
        merchantConfigurationData: null,
        merchantConfigurationIsError: true
      };

    case actions.RESET_MERCHANT_CONFIG_DATA:
      return {
        ...state,
        merchantConfigurationLoading: false,
        merchantConfigurationData: null,
        merchantConfigurationIsError: false,

        merchantFeeLoading: false,
        merchantFeeData: null,
        merchantFeeIsError: false
      };

    case actions.FETCHING_MERCHANT_SETTINGS_TYPE_DATA:
      return {
        ...state,
        merchantSettingsTypeData: null,
        merchantSettingsTypeLoading: true
      };

    case actions.FETCH_MERCHANT_SETTINGS_TYPE_DATA_SUCCESS:
      return {
        ...state,
        merchantSettingsTypeLoading: false,
        merchantSettingsTypeData: action.result,
        merchantSettingsTypeIsError: false,
        merchantSettingsTypeFilter: action.dataFilter
      };

    case actions.FETCH_MERCHANT_SETTINGS_TYPE_DATA_FAILED:
      return {
        ...state,
        merchantSettingsTypeLoading: false,
        merchantSettingsTypeData: null,
        merchantSettingsTypeIsError: true,
        merchantSettingsTypeFilter: action.dataFilter
      };

    case actions.ADDING_MERCHANT_SETTINGS_TYPE:
      return {
        ...state,
        merchantSettingsTypeIsError: false,
        merchantSettingsTypeLoading: true
      };

    case actions.ADD_MERCHANT_SETTINGS_TYPE_SUCCESS:
      return {
        ...state,
        merchantSettingsTypeLoading: action.loading,
        errorMessage: action.message,
        merchantSettingsTypeIsError: false
      };

    case actions.ADD_MERCHANT_SETTINGS_TYPE_FAILED:
      return {
        ...state,
        merchantSettingsTypeLoading: action.loading,
        errorMessage: action.message,
        merchantSettingsTypeIsError: true
      };

    case actions.ADDING_AMOUNT_LEVEL:
      return {
        ...state,
        amountLevelError: false,
        amountLevelLoading: true
      };

    case actions.ADD_AMOUNT_LEVEL_SUCCESS:
      return {
        ...state,
        amountLevelLoading: action.loading,
        errorMessage: action.message,
        amountLevelError: false
      };

    case actions.ADD_AMOUNT_LEVEL_FAILED:
      return {
        ...state,
        amountLevelLoading: action.loading,
        errorMessage: action.message,
        amountLevelError: true
      };

    case actions.EDITING_MERCHANT_AMOUNT_LEVEL_DATA:
      return {
        ...state,
        amountLevelError: false,
        amountLevelLoading: true
      };

    case actions.EDIT_MERCHANT_AMOUNT_LEVEL_DATA_SUCCESS:
      return {
        ...state,
        amountLevelLoading: action.loading,
        errorMessage: action.message,
        amountLevelError: false
      };

    case actions.EDIT_MERCHANT_AMOUNT_LEVEL_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        amountLevelLoading: action.loading,
        amountLevelError: true
      };

    case actions.EDITING_MERCHANT_SETTINGS_TYPE_DATA:
      return {
        ...state,
        merchantSettingsTypeIsError: false,
        merchantSettingsTypeLoading: true
      };

    case actions.EDIT_MERCHANT_SETTINGS_TYPE_DATA_SUCCESS:
      return {
        ...state,
        merchantSettingsTypeLoading: action.loading,
        errorMessage: action.message,
        merchantSettingsTypeIsError: false
      };

    case actions.EDIT_MERCHANT_SETTINGS_TYPE_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        merchantSettingsTypeLoading: action.loading,
        merchantSettingsTypeIsError: true
      };

    case actions.ADDING_MERCHANT_CONFIGURATION_DATA:
      return {
        ...state,
        merchantConfigurationIsError: false,
        merchantConfigurationLoading: true,
        pageLoading: true
      };

    case actions.ADD_MERCHANT_CONFIGURATION_DATA_SUCCESS:
      return {
        ...state,
        merchantConfigurationLoading: action.loading,
        errorMessage: action.message,
        merchantConfigurationIsError: false,
        pageLoading: false
      };

    case actions.ADD_MERCHANT_CONFIGURATION_DATA_FAILED:
      return {
        ...state,
        merchantConfigurationLoading: action.loading,
        errorMessage: action.message,
        merchantConfigurationIsError: true,
        pageLoading: false
      };

    case actions.EDITING_MERCHANT_CONFIG_DATA:
      return {
        ...state,
        merchantConfigurationIsError: false,
        merchantConfigurationLoading: true
      };

    case actions.EDIT_MERCHANT_CONFIG_DATA_SUCCESS:
      return {
        ...state,
        merchantConfigurationLoading: action.loading,
        errorMessage: action.message,
        merchantConfigurationIsError: false
      };

    case actions.EDIT_MERCHANT_CONFIG_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        merchantConfigurationLoading: action.loading,
        merchantConfigurationIsError: true
      };

    case actions.FETCHING_MERCHANT_PCHANNEL_CREDENTIAL_DATA:
      return {
        ...state,
        merchantPChannelConfigData: null,
        merchantPChannelConfigLoading: true
      };

    case actions.FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA_SUCCESS:
      return {
        ...state,
        merchantPChannelConfigLoading: false,
        merchantPChannelConfigData: action.result,
        merchantPChannelConfigIsError: false
      };

    case actions.FETCH_MERCHANT_PCHANNEL_CREDENTIAL_DATA_FAILED:
      return {
        ...state,
        merchantPChannelConfigLoading: false,
        merchantPChannelConfigData: null,
        merchantPChannelConfigIsError: true
      };

    case actions.SETTING_UP_MERCHANT_PCHANNEL_CREDENTIAL_DATA:
      return {
        ...state,
        merchantConfigurationIsError: false,
        merchantConfigurationLoading: true
      };

    case actions.SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA_SUCCESS:
      return {
        ...state,
        merchantConfigurationLoading: action.loading,
        errorMessage: action.message,
        merchantConfigurationIsError: false
      };

    case actions.SETUP_MERCHANT_PCHANNEL_CREDENTIAL_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        merchantConfigurationLoading: action.loading,
        merchantConfigurationIsError: true
      };

    case actions.FETCHING_MERCHANT_FEE_DATA:
      return {
        ...state,
        merchantFeeData: null,
        merchantFeeLoading: true
      };

    case actions.FETCH_MERCHANT_FEE_DATA_SUCCESS:
      return {
        ...state,
        merchantFeeLoading: false,
        merchantFeeData: action.result,
        merchantFeeIsError: false
      };

    case actions.FETCH_MERCHANT_FEE_DATA_FAILED:
      return {
        ...state,
        merchantFeeLoading: false,
        merchantFeeData: null,
        merchantFeeIsError: true
      };

    case actions.SETTING_UP_MERCHANT_FEE_DATA:
      return {
        ...state,
        merchantFeeIsError: false,
        merchantFeeLoading: true
      };

    case actions.SETUP_MERCHANT_FEE_DATA_SUCCESS:
      return {
        ...state,
        merchantFeeLoading: action.loading,
        errorMessage: action.message,
        merchantFeeIsError: false
      };

    case actions.SETUP_MERCHANT_FEE_DATA_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        merchantFeeLoading: action.loading,
        merchantFeeIsError: true
      };

    case actions.FETCHING_MIS_OPTIONS:
      return {
        ...state,
        misOptions: null,
        pageLoading: action.loading,
        misOptionsLoading: action.loading
      };

    case actions.FETCH_MIS_OPTIONS_SUCCESS:
      return {
        ...state,
        misOptionsLoading: action.loading,
        pageLoading: action.loading,
        misOptions: action.result,
        isError: false
      };

    case actions.FETCH_MIS_OPTIONS_FAILED:
      return {
        ...state,
        misOptionsLoading: action.loading,
        pageLoading: action.loading,
        misOptions: action.result,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_KYB_LINK_STATUS:
      return {
        ...state,
        kybLinkStatus: null,
        pageLoading: action.loading,
        kybLinkStatusLoading: action.loading
      };

    case actions.FETCH_KYB_LINK_STATUS_SUCCESS:
      return {
        ...state,
        kybLinkStatusLoading: action.loading,
        pageLoading: action.loading,
        kybLinkStatus: action.result,
        isError: false
      };

    case actions.FETCH_KYB_LINK_STATUS_FAILED:
      return {
        ...state,
        kybLinkStatusLoading: action.loading,
        pageLoading: action.loading,
        kybLinkStatus: action.result,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_MIS_MERCHANT_DETAILS:
      return {
        ...state,
        misMerchantDetails: null,
        pageLoading: action.loading,
        misMerchantDetailsLoading: action.loading
      };

    case actions.FETCH_MIS_MERCHANT_DETAILS_SUCCESS:
      return {
        ...state,
        misMerchantDetailsLoading: action.loading,
        pageLoading: action.loading,
        misMerchantDetails: action.result,
        isError: false
      };

    case actions.FETCH_MIS_MERCHANT_DETAILS_FAILED:
      return {
        ...state,
        misMerchantDetailsLoading: action.loading,
        pageLoading: action.loading,
        misMerchantDetails: action.result,
        isError: true,
        errorMessage: action.message
      };

    case actions.SAVING_MIS_DRAFT:
      return {
        ...state,
        pageLoading: true
      };

    case actions.SAVE_MIS_DRAFT_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        isError: false,
        errorMessage: action.message
      };

    case actions.SAVE_MIS_DRAFT_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        isError: true,
        errorMessage: action.message
      };

    case actions.SUBMITTING_MIS_FORM_DATA:
      return {
        ...state,
        pageLoading: true
      };

    case actions.SUBMIT_MIS_FORM_DATA_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        isError: false,
        errorMessage: action.message
      };

    case actions.SUBMIT_MIS_FORM_DATA_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_ALL_MERCHANT_FROM_ONBOARDING:
      return {
        ...state,
        merchantFromOnboarding: null,
        merchantFromOnboardingLoading: true
      };

    case actions.LOADING_MORE_MERCHANT_FROM_ONBOARDING:
      return {
        ...state,
        merchantFromOnboardingLoadMore: true
      };

    case actions.FETCH_ALL_MERCHANT_FROM_ONBOARDING_SUCCESS:
      return {
        ...state,
        merchantFromOnboardingLoading: action.loading,
        merchantFromOnboarding: action.result,
        merchantFromOnboardingIsError: false,
        merchantFilter: action.filter,
        merchantFromOnboardingPagination: action.pagination,
        merchantFromOnboardingLoadMore: false,
        activeMerchantFromOnboarding: null
      };

    case actions.FETCH_ALL_MERCHANT_FROM_ONBOARDING_FAILED:
      return {
        ...state,
        merchantFromOnboardingLoading: action.loading,
        merchantFromOnboardingIsError: true,
        merchantFromOnboardingLoadMore: false
      };

    case actions.EDITING_MERCHANT_SERVICE:
      return {
        ...state,
        pageLoading: true,
        merchantFromOnboardingLoading: true,
        isError: false
      };

    case actions.EDIT_MERCHANT_SERVICE_SUCCESS:
      return {
        ...state,
        merchantFromOnboardingLoading: action.loading,
        isError: false,
        errorMessage: action.message,
        pageLoading: false,
        activeMerchantFromOnboarding: null
      };

    case actions.EDIT_MERCHANT_SERVICE_FAILED:
      return {
        ...state,
        merchantFromOnboardingLoading: action.loading,
        pageLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS:
      return {
        ...state,
        activeMerchantFromOnboarding: null,
        pageLoading: action.loading
      };

    case actions.FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS_SUCCESS:
      return {
        ...state,
        pageLoading: action.loading,
        activeMerchantFromOnboarding: action.result,
        isError: false
      };

    case actions.FETCH_MERCHANT_SERVICES_AND_PAYMENT_CHANNELS_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        activeMerchantFromOnboarding: null,
        isError: true
      };

    case actions.EDITING_MERCHANT_PAYMENT_CHANNEL:
      return {
        ...state,
        pageLoading: true,
        merchantFromOnboardingLoading: true,
        isError: false
      };

    case actions.EDIT_MERCHANT_PAYMENT_CHANNEL_SUCCESS:
      return {
        ...state,
        merchantFromOnboardingLoading: action.loading,
        isError: false,
        errorMessage: action.message,
        pageLoading: false,
        activeMerchantFromOnboarding: null
      };

    case actions.EDIT_MERCHANT_PAYMENT_CHANNEL_FAILED:
      return {
        ...state,
        merchantFromOnboardingLoading: action.loading,
        pageLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_ALL_COSMOS_LEADS_AND_MERCHANTS:
      return {
        ...state,
        allCosmosLeadsMerchant: null,
        allCosmosLeadsMerchantLoading: action.loading
      };

    case actions.FETCH_ALL_COSMOS_LEADS_AND_MERCHANTS_SUCCESS:
      return {
        ...state,
        allCosmosLeadsMerchant: action.result,
        allCosmosLeadsMerchantLoading: action.loading,
        allCosmosLeadsMerchantIsError: false
      };

    case actions.FETCH_ALL_COSMOS_LEADS_AND_MERCHANTS_FAILED:
      return {
        ...state,
        allCosmosLeadsMerchant: action.result,
        allCosmosLeadsMerchantLoading: action.loading,
        allCosmosLeadsMerchantIsError: true
      };

    case actions.FETCHING_EXISTING_MERCHANT_LOGS:
      return {
        ...state,
        existingMerchantLogsLoading: action.loading,
        existingMerchantLogsData: null
      };

    case actions.FETCH_EXISTING_MERCHANT_LOGS_SUCCESS:
      return {
        ...state,
        existingMerchantLogsLoading: action.loading,
        existingMerchantLogsData: action.result,
        existingMerchantLogsIsError: false,
        existingMerchantLogsPagination: action.pagination,
        existingMerchantLogsLoadMore: false
      };

    case actions.LOADING_MORE_EXISTING_MERCHANT_LOGS:
      return {
        ...state,
        existingMerchantLogsLoadMore: true
      };

    case actions.FETCH_EXISTING_MERCHANT_LOGS_FAILED:
      return {
        ...state,
        existingMerchantLogsLoading: action.loading,
        existingMerchantLogsData: action.result,
        existingMerchantLogsIsError: true,
        existingMerchantLogsPagination: action.pagination,
        existingMerchantLogsLoadMore: false
      };
    case actions.RESET_EXISTING_MERCHANT_LOGS:
      return {
        ...state,
        existingMerchantLogsLoading: false,
        existingMerchantLogsData: null,
        existingMerchantLogsIsError: false,
        existingMerchantLogsPagination: null,
        existingMerchantLogsLoadMore: false
      };

    case actions.FETCHING_COMPANY_INFORMATION_DATA:
      return {
        ...state,
        companyInformationData: null,
        companyInformationLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.FETCH_COMPANY_INFORMATION_DATA_SUCCESS:
      return {
        ...state,
        companyInformationData: action.result,
        companyInformationLoading: action.loading,
        pageLoading: action.loading,
        isError: false
      };

    case actions.FETCH_COMPANY_INFORMATION_DATA_FAILED:
      return {
        ...state,
        companyInformationData: action.result,
        companyInformationLoading: action.loading,
        pageLoading: action.loading,
        isError: true
      };

    case actions.ADDING_COMPANY_INFORMATION:
      return {
        ...state,
        isError: false,
        companyInformationLoading: true,
        pageLoading: true
      };

    case actions.ADD_COMPANY_INFORMATION_SUCCESS:
      return {
        ...state,
        companyInformationLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.ADD_COMPANY_INFORMATION_FAILED:
      return {
        ...state,
        companyInformationLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.EDITING_COMPANY_INFORMATION:
      return {
        ...state,
        isError: false,
        companyInformationLoading: true,
        pageLoading: true
      };

    case actions.EDIT_COMPANY_INFORMATION_SUCCESS:
      return {
        ...state,
        companyInformationLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.EDIT_COMPANY_INFORMATION_FAILED:
      return {
        ...state,
        companyInformationLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.DOWNLOADING_MERCHANT_FILE:
      return {
        ...state,
        pageLoading: true
      };

    case actions.DOWNLOAD_MERCHANT_FILE_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_MERCHANT_FILE_FAILED:
      return {
        ...state,
        pageLoading: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_ALL_PARENT_MERCHANTS:
      return {
        ...state,
        parentMerchants: null,
        pageLoading: action.loading,
        parentMerchantsLoading: action.loading
      };

    case actions.FETCH_ALL_PARENT_MERCHANTS_SUCCESS:
      return {
        ...state,
        parentMerchantsLoading: action.loading,
        pageLoading: action.loading,
        parentMerchants: action.result,
        isError: false
      };

    case actions.FETCH_ALL_PARENT_MERCHANTS_FAILED:
      return {
        ...state,
        parentMerchantsLoading: action.loading,
        pageLoading: action.loading,
        parentMerchants: action.result,
        isError: true
      };

    case actions.MIGRATING_MERCHANT_INFORMATION:
      return {
        ...state,
        isError: false,
        merchantInformationLoading: true,
        pageLoading: true
      };

    case actions.MIGRATE_MERCHANT_INFORMATION_SUCCESS:
      return {
        ...state,
        merchantInformationLoading: action.loading,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };

    case actions.MIGRATE_MERCHANT_INFORMATION_FAILED:
      return {
        ...state,
        merchantInformationLoading: action.loading,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.FETCHING_MERCHANT_INFO_MIDS:
      return {
        ...state,
        merchantInfoMIDs: null,
        pageLoading: action.loading,
        merchantInfoMIDsLoading: action.loading
      };

    case actions.FETCH_MERCHANT_INFO_MIDS_SUCCESS:
      return {
        ...state,
        merchantInfoMIDsLoading: action.loading,
        pageLoading: action.loading,
        merchantInfoMIDs: action.result,
        isError: false
      };

    case actions.FETCH_MERCHANT_INFO_MIDS_FAILED:
      return {
        ...state,
        merchantInfoMIDsLoading: action.loading,
        pageLoading: action.loading,
        merchantInfoMIDs: action.result,
        isError: true
      };

    case actions.FETCHING_INTEGRATION_FORM_REQUESTS:
      return {
        ...state,
        integrationFormRequestsLoading: action.loading
      };

    case actions.FETCH_INTEGRATION_FORM_REQUESTS_SUCCESS:
      return {
        ...state,
        integrationFormRequestsLoading: action.loading,
        integrationFormRequestsData: action.result,
        integrationFormRequestsIsError: false,
        integrationFormRequestsPagination: action.pagination,
        integrationFormRequestsLoadMore: false,
        integrationFormRequestsFilter: action.filter
      };

    case actions.LOADING_MORE_INTEGRATION_FORM_REQUESTS:
      return {
        ...state,
        integrationFormRequestsLoadMore: true
      };

    case actions.FETCH_INTEGRATION_FORM_REQUESTS_FAILED:
      return {
        ...state,
        integrationFormRequestsLoading: action.loading,
        integrationFormRequestsIsError: true,
        integrationFormRequestsLoadMore: false,
        integrationFormRequestsData: action.payload
      };

    case actions.EDITING_INTEGRATION_CHANNEL_SUB_MID:
      return {
        ...state,
        integrationFormRequestsLoading: true,
        integrationFormRequestsIsError: false
      };

    case actions.EDIT_INTEGRATION_CHANNEL_SUB_MID_SUCCESS:
      return {
        ...state,
        integrationFormRequestsLoading: false,
        integrationFormRequestsIsError: false
      };

    case actions.EDIT_INTEGRATION_CHANNEL_SUB_MID_FAILED:
      return {
        ...state,
        integrationFormRequestsLoading: false,
        integrationFormRequestsIsError: true
      };

    case actions.FETCHING_INTEGRATION_FORM_REQUEST_BY_ID:
      return {
        ...state,
        integrationFormRequestByIdLoading: action.loading
      };

    case actions.FETCH_INTEGRATION_FORM_REQUEST_BY_ID_SUCCESS:
      return {
        ...state,
        integrationFormRequestByIdLoading: action.loading,
        integrationFormRequestById: action.result,
        integrationFormRequestByIdHasError: false
      };

    case actions.FETCH_INTEGRATION_FORM_REQUEST_BY_ID_FAILED:
      return {
        ...state,
        integrationFormRequestByIdLoading: action.loading,
        integrationFormRequestById: null,
        integrationFormRequestByIdHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.RESET_INTEGRATION_FORM_REQUEST_BY_ID:
      return {
        ...state,
        integrationFormRequestByIdLoading: false,
        integrationFormRequestByIdHasError: false,
        integrationFormRequestById: null
      };

    case actions.UPDATING_INTEGRATION_FORM_REQUEST_STATUS:
      return {
        ...state,
        integrationFormRequestByIdLoading: action.loading
      };

    case actions.UPDATE_INTEGRATION_FORM_REQUEST_STATUS_SUCCESS:
      return {
        ...state,
        integrationFormRequestByIdLoading: action.loading,
        integrationFormRequestById: action.result,
        integrationFormRequestByIdHasError: false
      };

    case actions.UPDATE_INTEGRATION_FORM_REQUEST_STATUS_FAILED:
      return {
        ...state,
        integrationFormRequestByIdLoading: action.loading,
        integrationFormRequestByIdHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.ASSIGNING_TOS_TO_IRF:
      return {
        ...state,
        integrationFormRequestByIdLoading: action.loading
      };

    case actions.ASSIGN_TOS_TO_IRF_SUCCESS:
      return {
        ...state,
        integrationFormRequestByIdLoading: action.loading,
        integrationFormRequestById: action.result,
        integrationFormRequestByIdHasError: false
      };

    case actions.ASSIGN_TOS_TO_IRF_FAILED:
      return {
        ...state,
        integrationFormRequestByIdLoading: action.loading,
        integrationFormRequestByIdHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.GENERATING_INTEGRATION_REQUEST_FORM_REPORT:
      return {
        ...state,
        integrationRequestFormReportLoading: true,
        integrationRequestFormReportIsError: false,
        pageLoading: true
      };

    case actions.GENERATE_INTEGRATION_REQUEST_FORM_REPORT_SUCCESS:
      return {
        ...state,
        integrationRequestFormReportIsError: false,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.GENERATE_INTEGRATION_REQUEST_FORM_REPORT_FAILED:
      return {
        ...state,
        integrationRequestFormReportLoading: action.loading,
        integrationRequestFormReportIsError: true,
        errorMessage: action.message,
        pageLoading: false
      };

    case actions.DOWNLOADING_INTEGRATION_REQUEST_FORM_REPORT:
      return {
        ...state,
        isDownloadingIntegrationRequestFormReportFile: true
      };

    case actions.DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT_SUCCESS:
      return {
        ...state,
        isDownloadingIntegrationRequestFormReportFile: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_INTEGRATION_REQUEST_FORM_REPORT_FAILED:
      return {
        ...state,
        isDownloadingIntegrationRequestFormReportFile: false,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA:
      return {
        ...state,
        // allIntegrationRequestFormReportFileData: null,
        allIntegrationRequestFormReportDataLoading: action.loading
      };

    case actions.FETCH_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA_SUCCESS:
      return {
        ...state,
        allIntegrationRequestFormReportDataLoading: action.loading,
        allIntegrationRequestFormReportFileData: action.result,
        allIntegrationRequestFormReportFileDataIsError: false,
        allIntegrationRequestFormReportFileDataPagination: action.pagination
      };

    case actions.FETCH_ALL_INTEGRATION_REQUEST_FORM_REPORT_DATA_FAILED:
      return {
        ...state,
        allIntegrationRequestFormReportDataLoading: action.loading,
        allIntegrationRequestFormReportFileData: action.result,
        allIntegrationRequestFormReportFileDataIsError: true,
        allIntegrationRequestFormReportFileDataPagination: action.pagination
      };

    case actions.FETCHING_INTEGRATION_FORM_LOGS:
      return {
        ...state,
        integrationFormLogsLoading: action.loading
      };

    case actions.FETCH_INTEGRATION_FORM_LOGS_SUCCESS:
      return {
        ...state,
        integrationFormLogsLoading: action.loading,
        integrationFormLogsData: action.result,
        integrationFormLogsIsError: false,
        integrationFormLogsPagination: action.pagination,
        integrationFormLogsLoadMore: false,
        integrationFormLogsFilter: action.filter
      };

    case actions.LOADING_MORE_INTEGRATION_FORM_LOGS:
      return {
        ...state,
        integrationFormLogsLoadMore: true
      };

    case actions.FETCH_INTEGRATION_FORM_LOGS_FAILED:
      return {
        ...state,
        integrationFormLogsLoading: action.loading,
        integrationFormLogsIsError: true,
        integrationFormLogsLoadMore: false,
        integrationFormLogsData: action.payload
      };
    case actions.RESET_INTEGRATION_FORM_LOGS:
      return {
        ...state,
        integrationFormLogsIsError: false,
        integrationFormLogsData: null,
        integrationFormLogsFilter: null
      };

    case actions.FETCHING_MERCHANT_PROFILE_LOGS:
      return {
        ...state,
        merchantProfileLogsLoading: action.loading
      };

    case actions.FETCH_MERCHANT_PROFILE_LOGS_SUCCESS:
      return {
        ...state,
        merchantProfileLogsLoading: action.loading,
        merchantProfileLogsData: action.result,
        merchantProfileLogsIsError: false,
        merchantProfileLogsPagination: action.pagination,
        merchantProfileLogsLoadMore: false,
        merchantProfileLogsFilter: action.filter
      };

    case actions.LOADING_MORE_MERCHANT_PROFILE_LOGS:
      return {
        ...state,
        merchantProfileLogsLoadMore: true
      };

    case actions.FETCH_MERCHANT_PROFILE_LOGS_FAILED:
      return {
        ...state,
        merchantProfileLogsLoading: action.loading,
        merchantProfileLogsIsError: true,
        merchantProfileLogsLoadMore: false,
        merchantProfileLogsData: action.payload
      };
    case actions.RESET_MERCHANT_PROFILE_LOGS:
      return {
        ...state,
        merchantProfileLogsIsError: false,
        merchantProfileLogsData: null,
        merchantProfileLogsFilter: null
      };

    case actions.FETCHING_MERCHANT_CREDENTIALS_BY_ID:
      return {
        ...state,
        merchantCredentialsByIdLoading: action.loading
      };

    case actions.FETCH_MERCHANT_CREDENTIALS_BY_ID_SUCCESS:
      return {
        ...state,
        merchantCredentialsByIdLoading: action.loading,
        merchantCredentialsById: action.result,
        merchantCredentialsByIdUnmaskedFields: action.unmasked_fields,
        merchantCredentialsByIdHasError: false
      };

    case actions.FETCH_MERCHANT_CREDENTIALS_BY_ID_FAILED:
      return {
        ...state,
        merchantCredentialsByIdLoading: action.loading,
        merchantCredentialsById: null,
        merchantCredentialsByIdHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.RESET_MERCHANT_CREDENTIALS_BY_ID:
      return {
        ...state,
        merchantCredentialsByIdLoading: false,
        merchantCredentialsByIdHasError: false,
        merchantCredentialsByIdUnmaskedFields: null,
        merchantCredentialsById: null
      };

    case actions.GENERATING_MERCHANT_CREDENTIAL:
      return {
        ...state,
        generateMerchantCredentialsLoading: action.loading
      };

    case actions.GENERATE_MERCHANT_CREDENTIAL_SUCCESS:
      return {
        ...state,
        generateMerchantCredentialsLoading: action.loading,
        merchantCredentialsById: action.result,
        generateMerchantCredentialsHasError: false
      };

    case actions.GENERATE_MERCHANT_CREDENTIAL_FAILED:
      return {
        ...state,
        generateMerchantCredentialsLoading: action.loading,
        generateMerchantCredentialsHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.ADDING_MERCHANT_PAYMENT_CHANNEL:
      return {
        ...state,
        addMerchantPaymentChannelLoading: action.loading,
        isError: false
      };

    case actions.ADD_MERCHANT_PAYMENT_CHANNEL_SUCCESS:
      return {
        ...state,
        addMerchantPaymentChannelLoading: action.loading,
        merchantPaymentChannelsById: action.result,
        addMerchantPaymentChannelHasError: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.ADD_MERCHANT_PAYMENT_CHANNEL_FAILED:
      return {
        ...state,
        addMerchantPaymentChannelLoading: action.loading,
        addMerchantPaymentChannelHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_MERCHANT_PAYMENT_CHANNELS_BY_ID:
      return {
        ...state,
        merchantPaymentChannelsByIdLoading: action.loading
      };

    case actions.FETCH_MERCHANT_PAYMENT_CHANNELS_BY_ID_SUCCESS:
      return {
        ...state,
        merchantPaymentChannelsByIdLoading: action.loading,
        merchantPaymentChannelsById: action.result,
        merchantPaymentChannelsByIdHasError: false
      };

    case actions.FETCH_MERCHANT_PAYMENT_CHANNELS_BY_ID_FAILED:
      return {
        ...state,
        merchantPaymentChannelsByIdLoading: action.loading,
        merchantPaymentChannelsById: null,
        merchantPaymentChannelsByIdHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.RESET_MERCHANT_PAYMENT_CHANNELS_BY_ID:
      return {
        ...state,
        merchantPaymentChannelsByIdLoading: false,
        merchantPaymentChannelsByIdHasError: false,
        merchantPaymentChannelsById: null
      };

    case actions.FETCHING_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID:
      return {
        ...state,
        merchantKrakenPaymentChannelsByIdLoading: action.loading
      };

    case actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID_SUCCESS:
      return {
        ...state,
        merchantKrakenPaymentChannelsByIdLoading: action.loading,
        merchantKrakenPaymentChannelsById: action.result,
        merchantKrakenPaymentChannelsByIdHasError: false
      };

    case actions.FETCH_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID_FAILED:
      return {
        ...state,
        merchantKrakenPaymentChannelsByIdLoading: action.loading,
        merchantKrakenPaymentChannelsById: null,
        merchantKrakenPaymentChannelsByIdHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.RESET_MERCHANT_KRAKEN_PAYMENT_CHANNELS_BY_ID:
      return {
        ...state,
        merchantKrakenPaymentChannelsByIdLoading: false,
        merchantKrakenPaymentChannelsByIdHasError: false,
        merchantKrakenPaymentChannelsById: null
      };

    case actions.UPDATING_MERCHANT_KRAKEN_PAYMENT_CHANNEL:
      return {
        ...state,
        isError: false
        // merchantKrakenPaymentChannelsByIdLoading: action.loading
      };

    case actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        // merchantKrakenPaymentChannelsByIdLoading: action.loading,
        merchantKrakenPaymentChannelsById: action.result
      };

    case actions.UPDATE_MERCHANT_KRAKEN_PAYMENT_CHANNEL_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true
        // merchantKrakenPaymentChannelsByIdLoading: action.loading
      };

    case actions.UPDATING_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS:
      return {
        ...state,
        isError: false
        // merchantKrakenPaymentChannelsByIdLoading: action.loading
      };

    case actions.UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        // merchantKrakenPaymentChannelsByIdLoading: action.loading,
        merchantKrakenPaymentChannelsById: action.result
      };

    case actions.UPDATE_ACTIVE_KRAKEN_PAYMENT_CHANNEL_STATUS_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true
        // merchantKrakenPaymentChannelsByIdLoading: action.loading
      };

    case actions.UPDATING_MERCHANT_PAYMENT_CHANNEL:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.UPDATE_MERCHANT_PAYMENT_CHANNEL_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        merchantPaymentChannelsById: action.result
      };

    case actions.UPDATE_MERCHANT_PAYMENT_CHANNEL_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.DELETING_MERCHANT_PAYMENT_CHANNEL:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.DELETE_MERCHANT_PAYMENT_CHANNEL_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        merchantPaymentChannelsById: action.result
      };

    case actions.DELETE_MERCHANT_PAYMENT_CHANNEL_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.DELETING_RM_ENDORSE_IRF_PAYMENT_CHANNEL:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        merchantPaymentChannelsById: action.result
      };

    case actions.DELETE_RM_ENDORSE_IRF_PAYMENT_CHANNEL_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.UPDATING_ACTIVE_PAYMENT_CHANNEL_STATUS:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading
      };

    case actions.UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: action.loading,
        merchantPaymentChannelsById: action.result
      };

    case actions.UPDATE_ACTIVE_PAYMENT_CHANNEL_STATUS_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: action.loading
      };

    case actions.STORING_TESTING_PROOF_FILES_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsTestingProofFilesLoading: action.loading
      };

    case actions.STORE_TESTING_PROOF_FILES_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsTestingProofFilesLoading: action.loading,
        presignedUrlsTestingProofFiles: action.result,
        presignedUrlsTestingProofFilesIsError: false
      };

    case actions.STORE_TESTING_PROOF_FILES_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsTestingProofFilesLoading: action.loading,
        presignedUrlsTestingProofFiles: action.result,
        presignedUrlsTestingProofFilesIsError: true
      };

    case actions.UPLOADING_TESTING_PROOF_FILES:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.UPLOAD_TESTING_PROOF_FILES_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        presignedUrlsTestingProofFiles: null,
        testingProofFilesById: action.result
      };

    case actions.UPLOAD_TESTING_PROOF_FILES_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false,
        presignedUrlsTestingProofFiles: null
      };

    case actions.DELETING_TESTING_PROOF_FILES:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.DELETE_TESTING_PROOF_FILES_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        testingIrfProofFilesById: action.result
      };

    case actions.DELETE_TESTING_PROOF_FILES_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.FETCHING_TESTING_PROOF_FILES_BY_ID:
      return {
        ...state,
        testingProofFilesByIdLoading: action.loading
      };

    case actions.FETCH_TESTING_PROOF_FILES_BY_ID_SUCCESS:
      return {
        ...state,
        testingProofFilesByIdLoading: action.loading,
        testingProofFilesById: action.result,
        testingProofFilesByIdHasError: false
      };

    case actions.FETCH_TESTING_PROOF_FILES_BY_ID_FAILED:
      return {
        ...state,
        testingProofFilesByIdLoading: action.loading,
        testingProofFilesById: null,
        testingProofFilesByIdHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.RESET_TESTING_PROOF_FILES_BY_ID:
      return {
        ...state,
        testingProofFilesByIdLoading: false,
        testingProofFilesByIdHasError: false,
        testingProofFilesById: null
      };

    case actions.DOWNLOADING_TESTING_PROOF_FILE:
      return {
        ...state,
        downloadTestingProofFileLoading: true,
        downloadTestingProofFileURL: null
      };

    case actions.DOWNLOAD_TESTING_PROOF_FILE_SUCCESS:
      return {
        ...state,
        downloadTestingProofFileLoading: false,
        downloadTestingProofFileIsError: false,
        downloadTestingProofFileURL: action.result
        // isError: false,
        // errorMessage: action.message
      };

    case actions.DOWNLOAD_TESTING_PROOF_FILE_FAILED:
      return {
        ...state,
        downloadTestingProofFileLoading: false,
        downloadTestingProofFileIsError: true
        // isError: true,
        // errorMessage: action.message
      };

    case actions.DOWNLOADING_IRF_TESTING_PROOF_FILE:
      return {
        ...state,
        downloadIRFTestingProofFileLoading: true
      };

    case actions.DOWNLOAD_IRF_TESTING_PROOF_FILE_SUCCESS:
      return {
        ...state,
        downloadIRFTestingProofFileLoading: false,
        downloadIRFTestingProofFileIsError: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_IRF_TESTING_PROOF_FILE_FAILED:
      return {
        ...state,
        downloadIRFTestingProofFileLoading: false,
        downloadIRFTestingProofFileIsError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.RELEASING_TOS_CREDENTIALS:
      return {
        ...state,
        isError: false,
        pageLoading: action.loading,
        merchantCredentialByIdDataIsLoading: action.loading
      };
    case actions.RELEASE_TOS_CREDENTIALS_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: false,
        merchantCredentialByIdDataIsLoading: action.loading,
        merchantCredentialByIdData: {
          ...state.merchantCredentialByIdData,
          status: action.result.status
        }
      };
    case actions.RELEASE_TOS_CREDENTIALS_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: false,
        merchantCredentialByIdDataIsLoading: action.loading
      };
    case actions.RELEASE_TOS_CONFIGURATION_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        isError: false,
        pageLoading: false
      };
    case actions.RELEASE_TOS_CONFIGURATION_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };
    case actions.STORING_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsForIRFProofTestFileLoading: true
      };
    case actions.STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD_SUCCESS:
      return {
        ...state,
        presignedUrlsForIRFProofTestFileLoading: false,
        presignedUrlsForIRFProofTestFileData: action.result,
        presignedUrlsForIRFProofTestFileIsError: false
      };

    case actions.STORE_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD_FAILED:
      return {
        ...state,
        presignedUrlsForIRFProofTestFileLoading: false,
        presignedUrlsForIRFProofTestFileData: action.result,
        presignedUrlsForIRFProofTestFileIsError: true
      };

    case actions.RESET_IRF_PROD_PROOF_TEST_FILES_FOR_UPLOAD:
      return {
        ...state,
        presignedUrlsForIRFProofTestFileLoading: false,
        presignedUrlsForIRFProofTestFileData: null,
        presignedUrlsForIRFProofTestFileIsError: null
      };

    case actions.UPLOADING_TESTING_PROOF_IRF_FILES:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.UPLOAD_TESTING_PROOF_IRF_FILES_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        presignedUrlsForIRFProofTestFileData: null,
        testingIrfProofFilesById: action.result
      };

    case actions.UPLOAD_TESTING_PROOF_IRF_FILES_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false,
        presignedUrlsForIRFProofTestFileData: null
      };

    case actions.FETCHING_TESTING_IRF_PROOF_FILES_BY_ID:
      return {
        ...state,
        testingIrfProofFilesByIdLoading: action.loading
      };

    case actions.FETCH_TESTING_IRF_PROOF_FILES_BY_ID_SUCCESS:
      return {
        ...state,
        testingIrfProofFilesByIdLoading: action.loading,
        testingIrfProofFilesById: action.result,
        testingIrfProofFilesByIdHasError: false
      };

    case actions.FETCH_TESTING_IRF_PROOF_FILES_BY_ID_FAILED:
      return {
        ...state,
        testingIrfProofFilesByIdLoading: action.loading,
        testingIrfProofFilesById: null,
        testingIrfProofFilesByIdHasError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.DOWNLOADING_TESTING_IRF_PROOF_FILE:
      return {
        ...state,
        downloadTestingIrfProofFileLoading: true
      };

    case actions.DOWNLOAD_TESTING_IRF_PROOF_FILE_SUCCESS:
      return {
        ...state,
        downloadTestingIrfProofFileLoading: false,
        downloadTestingIrfProofFileIsError: false,
        isError: false,
        errorMessage: action.message
      };

    case actions.DOWNLOAD_TESTING_IRF_PROOF_FILE_FAILED:
      return {
        ...state,
        downloadTestingIrfProofFileLoading: false,
        downloadTestingIrfProofFileIsError: true,
        isError: true,
        errorMessage: action.message
      };

    case actions.DELETING_TESTING_MERCHANT_PROOF_FILE:
      return {
        ...state,
        isError: false,
        pageLoading: true
      };

    case actions.DELETE_TESTING_MERCHANT_PROOF_FILE_SUCCESS:
      return {
        ...state,
        errorMessage: action.message,
        pageLoading: false,
        isError: false,
        testingIrfProofFilesById: action.result
      };

    case actions.DELETE_TESTING_MERCHANT_PROOF_FILE_FAILED:
      return {
        ...state,
        errorMessage: action.message,
        isError: true,
        pageLoading: false
      };

    case actions.ADDING_MERCHANT_CERTIFICATE:
      return {
        ...state,
        isError: false,
        merchantCertificateConfigurationLoading: action.loading
      };

    case actions.ADD_MERCHANT_CERTIFICATE_SUCCESS:
      return {
        ...state,
        merchantCertificateConfigurationLoading: action.loading,
        errorMessage: action.message,
        isError: false
      };

    case actions.ADD_MERCHANT_CERTIFICATE_FAILED:
      return {
        ...state,
        merchantCertificateConfigurationLoading: action.loading,
        errorMessage: action.message,
        isError: true
      };

    case actions.UPDATING_MERCHANT_CERTIFICATE:
      return {
        ...state,
        merchantCertificateConfigurationLoading: action.loading,
        isError: false
      };

    case actions.UPDATE_MERCHANT_CERTIFICATE_SUCCESS:
      return {
        ...state,
        merchantCertificateConfigurationLoading: action.loading,
        errorMessage: action.message,
        isError: false
      };

    case actions.UPDATE_MERCHANT_CERTIFICATE_FAILED:
      return {
        ...state,
        merchantCertificateConfigurationLoading: action.loading,
        errorMessage: action.message,
        isError: true
      };

    case actions.UPDATING_MERCHANT_CERTIFICATE_STATUS:
      return {
        ...state,
        merchantCertificateConfigurationLoading: action.loading,
        isError: false
      };

    case actions.UPDATE_MERCHANT_CERTIFICATE_STATUS_SUCCESS:
      return {
        ...state,
        merchantCertificateConfigurationLoading: action.loading,
        errorMessage: action.message,
        isError: false
      };

    case actions.UPDATE_MERCHANT_CERTIFICATE_STATUS_FAILED:
      return {
        ...state,
        merchantCertificateConfigurationLoading: action.loading,
        errorMessage: action.message,
        isError: true
      };

    case actions.FETCHING_TEST_MERCHANT_CERTIFICATES:
      return {
        ...state,
        merchantTestCertificateDataLoading: action.loading
      };

    case actions.FETCH_TEST_MERCHANT_CERTIFICATES_SUCCESS:
      return {
        ...state,
        merchantTestCertificateDataLoading: false,
        merchantTestCertificateHasError: null,
        merchantTestCertificateData: action.result
      };

    case actions.FETCH_TEST_MERCHANT_CERTIFICATES_FAILED:
      return {
        ...state,
        merchantTestCertificateDataLoading: false,
        merchantTestCertificateHasError: true,
        merchantTestCertificateData: action.result
      };
    case actions.RESET_TEST_MERCHANT_CERTIFICATES:
      return {
        ...state,
        merchantTestCertificateDataLoading: false,
        merchantTestCertificateData: null,
        merchantTestCertificateHasError: false
      };

    case actions.FETCHING_PROD_MERCHANT_CERTIFICATES:
      return {
        ...state,
        merchantProdCertificateDataLoading: action.loading
      };

    case actions.FETCH_PROD_MERCHANT_CERTIFICATES_SUCCESS:
      return {
        ...state,
        merchantProdCertificateDataLoading: false,
        merchantProdCertificateData: action.result,
        merchantProdCertificateHasError: false
      };

    case actions.FETCH_PROD_MERCHANT_CERTIFICATES_FAILED:
      return {
        ...state,
        merchantProdCertificateDataLoading: false,
        merchantProdCertificateData: action.result,
        merchantProdCertificateHasError: true
      };

    case actions.RESET_PROD_MERCHANT_CERTIFICATES:
      return {
        ...state,
        merchantProdCertificateDataLoading: false,
        merchantProdCertificateData: null,
        merchantProdCertificateHasError: false
      };

    case actions.FETCHING_BUSINESS_TYPE_REQUIREMENT:
      return {
        ...state,
        businessTypeRequiredFields: null,
        businessTypeRequiredFieldsLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.FETCH_BUSINESS_TYPE_REQUIREMENT_SUCCESS:
      return {
        ...state,
        businessTypeRequiredFields: action.result,
        businessTypeRequiredFieldsLoading: action.loading,
        pageLoading: action.loading,
        isError: false
      };

    case actions.FETCH_BUSINESS_TYPE_REQUIREMENT_FAILED:
      return {
        ...state,
        pageLoading: action.loading,
        businessTypeRequiredFieldsLoading: action.loading,
        businessTypeRequiredFields: action.result,
        isError: true,
        errorMessage: action.message
      };

    case actions.UPDATE_UPLOADED_FILE_METADATA_LOADING:
      return {
        ...state,
        updateUploadedFileMetadataLoading: action.loading,
        isError: false
      };

    case actions.UPDATE_UPLOADED_FILE_METADATA_SUCCESS:
      return {
        ...state,
        updateUploadedFileMetadataLoading: action.loading,
        errorMessage: action.message,
        isError: false
      };

    case actions.UPDATE_UPLOADED_FILE_METADATA_FAILED:
      return {
        ...state,
        updateUploadedFileMetadataLoading: action.loading,
        errorMessage: action.message,
        isError: true
      };

      case actions.SAVING_UPLOADED_FILE_METADATA:
      return {
        ...state,
        saveUploadedFileMetadataLoading: action.loading,
        isError: false
      };

    case actions.SAVE_UPLOADED_FILE_METADATA_SUCCESS:
      return {
        ...state,
        saveUploadedFileMetadataLoading: action.loading,
        errorMessage: action.message,
        isError: false
      };

    case actions.SAVE_UPLOADED_FILE_METADATA_FAILED:
      return {
        ...state,
        saveUploadedFileMetadataLoading: action.loading,
        errorMessage: action.message,
        isError: true
      };

    case actions.MIGRATING_MERCHANT_PAYMENT_CHANNEL_CONFIG:
      return {
        ...state,
        isError: false
      };

    case actions.MIGRATE_MERCHANT_PAYMENT_CHANNEL_CONFIG_SUCCESS:
      return {
        ...state,
        isError: false,
        errorMessage: action.message,
        merchantKrakenPaymentChannelsById: action.result
      };

    case actions.MIGRATE_MERCHANT_PAYMENT_CHANNEL_CONFIG_FAILED:
      return {
        ...state,
        isError: true,
        errorMessage: action.message
      };

    case actions.FETCHING_COMPANY_PROFILE_DATA:
      return {
        ...state,
        companyProfileData: null,
        companyProfileDataLoading: action.loading,
        pageLoading: action.loading
      };

    case actions.FETCH_COMPANY_PROFILE_DATA_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        isError: false,
        companyProfileData: action.result,
        companyProfileDataLoading: false,
        companyProfileDataPagination: action.pagination,
        companyProfileDataFilter: action.filter,
        companyProfileDataCache: action.cache,
      };

    case actions.FETCH_COMPANY_PROFILE_DATA_FAILED:
      return {
        ...state,
        companyProfileDataLoading: false,
        isError: true,
        companyProfileDataFilter: null,
      };

    // case actions.FETCHING_MERCHANT_DATA:
    //   return {
    //     ...state,
    //     merchantData: null,
    //     pageLoading: action.loading,
    //     merchantLoading: action.loading
    //   };

    // case actions.LOADING_MORE_MERCHANT_DATA:
    //   return {
    //     ...state,
    //     merchantDataLoadMore: true
    //   };

    // case actions.FETCH_MERCHANT_DATA_SUCCESS:
    //   return {
    //     ...state,
    //     merchantLoading: action.loading,
    //     merchantFilter: action.filter,
    //     pageLoading: action.loading,
    //     merchantData: action.result,
    //     isError: false,
    //     merchantDataPagination: action.pagination,
    //     merchantDataLoadMore: false
    //   };

    // case actions.FETCH_MERCHANT_DATA_FAILED:
    //   return {
    //     ...state,
    //     merchantLoading: action.loading,
    //     merchantFilter: null,
    //     pageLoading: action.loading,
    //     merchantData: action.result,
    //     isError: true,
    //     merchantDataLoadMore: false
    //   };

    case authActions.LOGOUT:
      // reset all redux param values
      return initState;
    default:
      return state;
  }
}
